import { Dispatch, SetStateAction } from 'react';
import { Box, Text, ChakraProvider } from '@chakra-ui/react';
import ChartHeader from '@/components/ChartHeader';
import { chakraExtendedTheme, trioUITheme } from '@/styles/theme';
import * as Styles from './ChartFromReadyToHire.styles';
import Loading from '../general/Loading';

type ChartFromReadyToHireData = {
  total: number;
  name: string;
};

export type ChartFromReadyToHireProps = {
  isLoading: boolean;
  selectedDate: string;
  setSelectedDate: Dispatch<SetStateAction<string>>;
  title: string;
  tooltipMessage: string;
  data: ChartFromReadyToHireData[];
};
const style = {
  height: '115px',
};

const ChartFromReadyToHire = ({
  selectedDate,
  setSelectedDate,
  title,
  tooltipMessage,
  data,
  isLoading,
}: ChartFromReadyToHireProps): JSX.Element => (
  <ChakraProvider theme={chakraExtendedTheme}>
    <Box
      mb="29px"
      data-testid="chart-ready-to-hire"
      shadow="0px 4px 6px rgba(0, 0, 0, 0.07)"
      w="100%"
      py="38px"
      px="32px"
      bg="white"
      borderRadius="16px"
    >
      <ChartHeader
        withDateFilter
        selectedDate={selectedDate}
        onSelectFilter={setSelectedDate}
        title={title}
        tooltipMessage={tooltipMessage}
      />
      <Box display="flex" mt="22px" justifyContent="space-around">
        {isLoading && (
          <div style={style}>
            <Loading size={25} sx={{ marginTop: 8 }} />
          </div>
        )}
        {!!data?.length &&
          data.map((item) => (
            <Box
              key={`${item.name}-box`}
              w="64px"
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
            >
              <Text
                mb="8px"
                lineHeight="30px"
                fontWeight={600}
                fontSize={26}
                color={trioUITheme.colors['neutral-90']}
              >
                {item.total}
              </Text>
              <Styles.CustomUserInitials firstName={item.name} />

              <Text mt="4px" fontSize={14} color={trioUITheme.colors['neutral-90']}>
                {item.name.split(' ')[0]}
              </Text>
            </Box>
          ))}

        {!data?.length && !isLoading && (
          <Box
            h={115}
            data-testid="chart-empty-state"
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
          >
            <Text
              textAlign="center"
              fontWeight={600}
              fontSize={18}
              color={trioUITheme.colors['neutral-50']}
              mb="16px"
            >
              Your search didn’t match any result
            </Text>
            <Text textAlign="center" fontSize={14} color={trioUITheme.colors['neutral-90']}>
              Try to choose different options.
            </Text>
          </Box>
        )}
      </Box>
    </Box>
  </ChakraProvider>
);

export default ChartFromReadyToHire;
